export function daojishi(storptimes) {
  //也可以传截止的具体时间，改一下参数
  var newtime = new Date(); //获取当前时间
  var storptime = new Date(storptimes); //获取截止时间
  var mistiming = storptime.getTime() - newtime.getTime(); //   获取截止时间距离现在的毫秒差
  if (mistiming > 0) {
    var minutes = Math.floor((mistiming / 1000 / 60) % 60); //获取分钟数
    var seconds = Math.floor((mistiming / 1000) % 60); //获取秒数

    // 判断分、秒是不是两位数，如果是直接输出，如果不是在前边加个0;
    minutes < 10 ? (minutes = "0" + minutes) : minutes;
    seconds < 10 ? (seconds = "0" + seconds) : seconds;
    var rels = `${minutes}分${seconds}秒`;
  }

  // 判断时间差是不是正数，就是截止时间是不是比现在的时间晚
  var mis = mistiming > 0 ? rels : "已超时";
  return mis;
}

/**
 * 开源库选项
 * @returns 
 */
export function selectOptionsList() {
  return [
    {
      value: 'wh-self', label: '供应商自己库'
    }, {
      value: 'system', label: '系统库'
    }
  ];
}

/**
 * 将来源库返回成0跟1
 * @param {*} sopList 
 * @returns 
 */
export function getSelectOptionParams1(sopList){ // 设置搜索库存区参数()
  var sop = ''
  if (sopList.indexOf("wh-self") > -1) { // 供应商自己
    sop = sop + ',1'
  }
  if (sopList.indexOf("system") > -1) { // 系统
    sop = sop + ',0'
  }
  return sop
}

/**
 * 配货要求
 * type: '0' 不需要拼接
 * type: '1' label+label1拼接中间加入数字
 */
export function selectAllocationRequirementsList() {
  return [
    {value: '1', label: '发黄显旧不配', type: '0'},
    {value: '2', label: '副本不够不配', type: '0'},
    {value: '3', label: '副本不够有多少配多少', type: '0'},
    {value: '4', label: '副本不够',label1: '本起配', type: '1',}
  ];
}
/**
 * 配货要求1 将选项返回字符串。
 */
export function getApStr1(valueList, num1) {
  if(!valueList || valueList.length <= 0){
    return ''
  }
  if(!num1){
    num1 = 0
  }
  var resStart = '（';
  var resEnd = '）';
  var resContent = '';
  var slist = selectAllocationRequirementsList();
  slist.forEach((sVal) => {
    if(valueList.indexOf(sVal.value) > -1 && sVal.type === '0'){
      resContent += sVal.label + '，'
    }
    if(valueList.indexOf(sVal.value) > -1 && sVal.type === '1'){
      resContent += sVal.label + ' ' + num1 + ' ' + sVal.label1 + '，'
    }
  });
  return resStart + resContent + resEnd;
}
